/*
  Envío del formulario de inscripción a un evento.

  Va contra nuestro Worker y no por el formulario de contacto de Shopify, porque el nativo
  entrega SIEMPRE al correo de la tienda —e-shop@—, y las inscripciones tienen que llegar a
  Marketing. El Worker crea el registro en Freshdesk con copia a quien corresponda.

  Sin dependencias: el tema ya carga Alpine, pero aquí no hace falta estado reactivo, solo
  recoger campos y enviarlos.
*/
(function () {
  "use strict";

  /**
   * El aviso se pinta con textContent, NUNCA con innerHTML: el texto puede venir del
   * servidor y meterlo como HTML sería una vía de inyección.
   */
  function aviso(caja, texto, mal) {
    caja.textContent = texto;
    caja.className = "ev-form__aviso" + (mal ? " ev-form__aviso--mal" : "");
    caja.hidden = false;
    caja.setAttribute("role", mal ? "alert" : "status");
  }

  function inicia(form) {
    if (form.dataset.evListo === "1") return;
    form.dataset.evListo = "1";

    var caja = form.querySelector("[data-ev-aviso]");
    var boton = form.querySelector("[data-ev-enviar]");
    var textoBoton = boton ? boton.textContent : "";

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      // La validación nativa del navegador ya cubre los campos obligatorios y el formato
      if (!form.reportValidity()) return;

      var privacidad = form.querySelector("[data-ev-privacidad]");
      if (privacidad && !privacidad.checked) {
        aviso(caja, "Tienes que aceptar la política de privacidad para poder inscribirte.", true);
        return;
      }

      var v = function (n) {
        var el = form.querySelector('[name="' + n + '"]');
        return el ? String(el.value || "").trim() : "";
      };

      /* Las preguntas de cualificación se recogen por su etiqueta, que es lo que se quiere
         leer en el correo: el nombre del campo por sí solo no dice qué se preguntó.

         Una casilla manda «Sí» o «No», nunca su `value` —que en un checkbox es «on»— y el
         «No» se manda igual que el «Sí»: en una casilla como la del speed dating, saber que
         alguien la dejó sin marcar es tan útil como saber que la marcó. */
      var respuestas = {};
      Array.prototype.forEach.call(form.querySelectorAll("[data-ev-pregunta]"), function (el) {
        var clave = el.dataset.evPregunta;
        if (!clave) return;
        if (el.type === "checkbox") {
          respuestas[clave] = el.checked ? "Sí" : "No";
          return;
        }
        var valor = String(el.value || "").trim();
        if (valor) respuestas[clave] = valor;
      });

      var comercial = form.querySelector("[data-ev-comercial]");

      var cuerpo = {
        evento: form.dataset.evEvento || document.title,
        nombre: v("nombre"),
        apellidos: v("apellidos"),
        email: v("email"),
        empresa: v("empresa"),
        cargo: v("cargo"),
        telefono: v("telefono"),
        provincia: v("provincia"),
        /* Cómo conoció el evento. Va aparte de `respuestas` —donde viajan las casillas y
           los desplegables que son bloques— porque tiene columna propia en la base: así se
           cuenta y se compara entre eventos sin abrir ningún JSON. */
        canal: v("canal"),
        /* El campo se llama siempre `provincia`; lo que cambia de un evento a otro es cómo
           se rotula esa fila en el aviso. */
        localidad_etiqueta: form.dataset.evLocalidad || "",
        /* La clave del evento en el catálogo del Worker. Es lo ÚNICO que decide el
           contenido del correo de confirmación: el texto y los enlaces salen de allí, no
           de aquí, para que nadie pueda hacer que el buzón de Marketing mande lo que le
           apetezca. */
        evento_id: form.dataset.evId || "",
        respuestas: respuestas,
        comunicaciones: !!(comercial && comercial.checked),
        pagina: location.pathname,
        nickname: v("nickname"),
      };

      if (boton) {
        boton.disabled = true;
        boton.textContent = "Enviando…";
      }
      if (caja) caja.hidden = true;

      fetch(form.dataset.evDestino, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cuerpo),
      })
        .then(function (r) {
          return r.json().then(function (d) {
            return { ok: r.ok, d: d };
          });
        })
        .then(function (res) {
          if (!res.ok || !res.d || res.d.ok !== true) {
            throw new Error((res.d && res.d.error) || "No se ha podido enviar.");
          }
          aviso(caja, form.dataset.evExito ||
            "Hemos recibido tu solicitud. Te confirmamos la plaza por correo.", false);
          form.reset();
          if (boton) boton.hidden = true;
        })
        .catch(function (err) {
          aviso(caja, err.message || "No se ha podido enviar. Inténtalo de nuevo.", true);
          if (boton) {
            boton.disabled = false;
            boton.textContent = textoBoton;
          }
        });
    });
  }

  function arranca() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-ev-form]"), inicia);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arranca);
  } else {
    arranca();
  }

  /* El tema recarga secciones por AJAX al editarlas: sin esto, el formulario recargado se
     queda sin escuchar el envío. */
  document.addEventListener("shopify:section:load", arranca);
})();
